import { useFormik } from "formik";
import classNames from "classnames";

import { AscButton } from "../../components";
import AscTextInput from "../../components/AscInputFields/AscTextInput/AscTextInput";
import AscHeading from "../../components/AscTypography/AscHeading/AscHeading";
import AscParagraph from "../../components/AscTypography/AscParagraph/AscParagraph";
import AscAnimationOnScroll from "../../components/AscAnimationOnScroll/AscAnimationOnScroll";
import {
  shibbolethInitialValues,
  shibbolethEmailCheckSchema,
} from "./AscSignInView.helper";
import styles from "./AscSignInView.module.scss";

export interface AscSignInViewProps {
  loading?: boolean;
  onShibbolethCheck: (values: { email: string }) => void;
  setShowShibbolethEmailCheck: (show: boolean) => void;
}

export default function AscSignInView({
  loading,
  onShibbolethCheck,
  setShowShibbolethEmailCheck,
}: AscSignInViewProps) {
  const formik = useFormik({
    initialValues: shibbolethInitialValues,
    validationSchema: shibbolethEmailCheckSchema,
    onSubmit: (values) => onShibbolethCheck(values),
  });

  return (
    <form
      onSubmit={formik?.handleSubmit}
      data-testid="asc-sign-in-view"
      className={styles.ground}
    >
      <header className={styles.heading}>
        <AscHeading className={styles.title} level={1}>
          Shibboleth
        </AscHeading>
        <AscParagraph className={styles.subTitle}>
          Check your account exists or not in our platform
        </AscParagraph>
      </header>
      <AscAnimationOnScroll className={styles.form}>
        <div className={styles.fieldGroup}>
          <label className={styles.fieldLabel} htmlFor="email">
            Email
          </label>
          <AscTextInput
            className={styles.inputField}
            placeholder="Enter your email"
            id="email"
            name="email"
            data-testid="asc-sign-in-email"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
          />
          {formik.errors.email && formik.touched.email && (
            <div className={styles.fieldError}>{formik.errors.email}</div>
          )}
        </div>
      </AscAnimationOnScroll>
      <footer className={classNames(styles.footer, styles.shibbolethFooter)}>
        <AscButton
          className={styles.footerButton}
          variant="outlined"
          size="large"
          fullWidth
          type="submit"
          data-testid="asc-shibboleth-check-back"
          onClick={() => setShowShibbolethEmailCheck(false)}
        >
          Back
        </AscButton>
        <AscButton
          className={styles.footerButton}
          variant="primary"
          size="large"
          fullWidth
          type="submit"
          data-testid="asc-shibboleth-check-submit"
          loading={loading}
        >
          Submit
        </AscButton>
      </footer>
    </form>
  );
}
